module.exports = __webpack_public_path__ + "static/media/missao.84d02a1c.svg";